var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.066,
    height: 30.062,
    viewBox: "0 0 30.066 30.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163118",
    "data-name": "Group 163118",
    transform: "translate(0.001 -0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97824",
    "data-name": "Path 97824",
    d: "M48.009,46.022h3.5a1,1,0,0,0,0-2h-3.5a2,2,0,0,1-2-2V37a1,1,0,1,0-2,0v5.011a4.014,4.014,0,0,0,4.009,4.009Z",
    transform: "translate(-31.97 -27.982)",
    fill: "#ed3237"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97825",
    "data-name": "Path 97825",
    d: "M20.2,44.2a4.647,4.647,0,0,0,.4,3.617,4.547,4.547,0,0,0,3.9,2.241,4.456,4.456,0,0,0,1.237-.177l2.281-.651a3.627,3.627,0,0,1,2.181.025,14.95,14.95,0,0,0,6.258.733A15.152,15.152,0,0,0,50.016,36.11,15,15,0,0,0,35.024,20c-.366,0-.733.015-1.083.039a15.153,15.153,0,0,0-13.88,13.549,14.872,14.872,0,0,0,.716,6.2,3.548,3.548,0,0,1,.08,2.11Zm1.859-10.421A13.136,13.136,0,0,1,34.088,22.036c.305-.02.621-.035.941-.035a12.848,12.848,0,0,1,7.732,2.522,13.035,13.035,0,0,1-6.485,23.465c-.42.039-.841.06-1.252.06a12.9,12.9,0,0,1-4.161-.69,5.594,5.594,0,0,0-3.384-.055l-2.281.651A2.522,2.522,0,0,1,22.341,46.8a2.644,2.644,0,0,1-.212-2.05l.656-2.306a5.542,5.542,0,0,0-.105-3.3,12.925,12.925,0,0,1-.621-5.371Z",
    transform: "translate(-19.993 -19.996)",
    fill: "#314186"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.7d8dcf342b51451ca0fb6bbfb8864688.svg";
export { ForwardRef as ReactComponent };